import React, { useCallback, useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import * as PropTypes from 'prop-types';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import { settingsZwActions } from '../../redux/settingsZweckertrage/actions';
import { settingsStActions } from '../../redux/settingsStiftung/actions';

import { selectBranches } from '../../redux/branches/selectors';
import { selectSettingsZw } from '../../redux/settingsZweckertrage/selectors';
import { selectSettingsSt } from '../../redux/settingsStiftung/selectors';

import { Header } from '../../components/layouts/Header';
import { TopBarAllPages } from '../../containers/TopBarAllPages';
import { Footer } from '../../components/layouts/Footer';
import { BottomBar } from '../../containers/BottomBar';
import AuthService from '../../services/AuthService';
import { IS_MOBILE } from '../../constants/platform';

import { TYPES } from '../../containers/ProjectsSupported';

import {
	Wrapper,
	ProjectTitle,
	ProjectSubTitle,
	ProjectOrganizationName,
	ProjectDivider,
	ProjectDescription,
	EGMTextWrap
} from './ProjectsSupported.styled';
import { Page404 } from '../Page404';
import { convertToEuro, decodeHtmlEntities } from '../../utils/helpers';
import { ProjectsSupportedSubTitle } from './ProjectsSupportedSubTitle';
import EGM_LOGO from './img/egm.png';

const Shape = () => (
	<svg width='39px' height='39px' viewBox='0 0 39 39' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
		<title>Shape</title>
		<g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g id='Project-Detail-v2-Copy' transform='translate(-476.000000, -252.000000)' fill='#9E9E9E'>
				<path d='M506.378214,252.924696 L490.903571,263.092715 L481.181429,263.092715 C480.415357,263.092715 479.649286,263.264345 478.952857,263.595046 C477.156071,264.453195 476,266.278331 476,268.280679 L476,274.649122 C476,276.655655 477.156071,278.469629 478.952857,279.334755 C479.398571,279.544059 479.872143,279.69755 480.345714,279.767318 L481.404286,287.386007 C481.696786,289.465099 483.465714,291 485.541071,291 L487.142857,291 C489.455,291 491.321429,289.130212 491.321429,286.813907 L491.321429,280.116159 L506.378214,290.009291 C510.083214,292.437225 515,289.772079 515,285.334821 L515,257.590794 C515,253.150745 510.083214,250.48839 506.378214,252.924696 Z M512,257.766715 C512,255.569469 509.56625,254.25195 507.7375,255.457604 L492.145,265.735356 C491.925,265.88589 491.66375,265.974277 491.375,265.974277 L481.365,265.974277 C481.0075,265.974277 480.66375,266.052997 480.3475,266.203531 C479.5225,266.59713 479,267.431282 479,268.346916 L479,274.650015 C479,275.572555 479.5225,276.401183 480.3475,276.787876 C480.66375,276.939791 481.0075,277.022654 481.365,277.022654 L491.375,277.022654 C491.66375,277.022654 491.925,277.105517 492.145,277.257432 L507.7375,287.546233 C509.56625,288.747744 512,287.421939 512,285.226074 L512,257.766715 Z M489,280 L483,280 L484.106494,286.853333 C484.215584,287.506667 484.87013,288 485.649351,288 L487.441558,288 C488.298701,288 489,287.4 489,286.666667 L489,280 Z' id='Shape' />
			</g>
		</g>
	</svg>
);

const Heart = () => (
	<svg width='41px' height='37px' viewBox='0 0 41 37' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
		<title>Group 3</title>
		<g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g id='Project-Detail-v2-Copy' transform='translate(-730.000000, -252.000000)' fill='#9E9E9E'>
				<g id='Group-4' transform='translate(257.000000, 185.000000)'>
					<g id='Group-3' transform='translate(473.000000, 67.000000)'>
						<path d='M35.8435605,5.17314815 C32.6141285,1.92948148 27.3770639,1.92948148 24.1476319,5.17314815 L21.4675996,7.86318519 C21.2106664,8.12081481 20.8621665,8.2647037 20.5,8.2647037 C20.1378335,8.2647037 19.7893336,8.12081481 19.5337671,7.86318519 L16.8523681,5.17314815 C13.6229361,1.92948148 8.3858715,1.92948148 5.15643945,5.17314815 C1.92564074,8.41544444 1.92564074,13.6749259 5.15643945,16.9185926 C5.16873945,16.9309259 5.18240611,16.9446296 5.1947061,16.956963 L20.5,33.6083333 L35.8052939,16.956963 C35.8175939,16.9446296 35.8312606,16.9309259 35.8435605,16.9185926 C39.0743593,13.6749259 39.0743593,8.41544444 35.8435605,5.17314815 Z M22.2137993,3.23544444 C26.5105976,-1.07848148 33.4792282,-1.07848148 37.7773931,3.23544444 C42.0673581,7.54251852 42.0741914,14.5204444 37.7978931,18.8343704 L21.5044996,36.5587407 C21.2461997,36.8396667 20.8812998,37 20.5,37 C20.1187002,37 19.7538003,36.8396667 19.4955004,36.5587407 L3.2021069,18.8343704 C-1.0741914,14.5204444 -1.06735806,7.54251852 3.22260689,3.23544444 C7.52077184,-1.07848148 14.4894024,-1.07848148 18.7862007,3.23544444 L20.5,4.95525926 L22.2137993,3.23544444 Z' id='Shape' />
					</g>
				</g>
			</g>
		</g>
	</svg>
);

const Amount = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='34'
		height='39'
		viewBox='0 0 34 39'
	>
		<path
			fill='#9E9E9E'
			d='M16.702 1.188l.554.176.145-.04c3.24-.838 5.844-.823 7.816.136l.34.18c.655.369.92 1.175.642 1.862l-.08.17-3.922 7.04c7.719 6.653 11.412 13.387 10.894 20.34-1.213 6.83-3.537 8.09-14.698 7.852l-.403-.01-1.202-.032-1.787.047C4.517 39.127 1.857 37.976.566 31.85l-.05-.241-.134-.712c-.496-6.754 3.183-13.43 10.869-20.033L7.18 4.687c-.363-.55-.323-1.28.097-1.786C9.31.449 12.522-.056 16.702 1.188zm3.104 11.355l-5.98.001-.783.663C6.395 18.938 3.18 24.493 3.235 29.75l.007.315.025.458c.858 4.831 1.925 5.604 10.808 5.438l.385-.008 2.33-.059c10.834.33 12.377-.093 13.287-4.538l.034-.17.096-.51c.428-5.838-2.972-11.877-10.38-18.115l-.02-.018zm-2.19 3.176c.904 0 1.655.084 2.255.251.6.167 1.192.37 1.776.606l-.684 2.006-.06-.03c-.134-.064-.367-.154-.696-.27-.384-.134-.788-.236-1.212-.305-.423-.07-.823-.104-1.2-.104-.455 0-.91.057-1.361.17-.452.115-.876.309-1.272.582-.396.273-.752.64-1.068 1.1-.316.462-.566 1.039-.75 1.732h6.54l-.397 1.431h-6.419l-.034.296c-.041.383-.062.725-.062 1.026 0 .57.016.99.048 1.26h5.46l-.396 1.43H13.2l.06.346c.129.675.315 1.257.558 1.747.284.57.624 1.038 1.02 1.4.396.364.842.627 1.338.79.496.163 1.02.244 1.572.244.648 0 1.233-.055 1.757-.165.524-.11 1.002-.247 1.434-.41l.708 2.007-.2.08c-.417.157-.932.306-1.546.446-.716.163-1.533.244-2.453.244-.856 0-1.658-.134-2.406-.403-.748-.27-1.418-.68-2.01-1.23-.592-.55-1.092-1.248-1.5-2.092-.407-.844-.695-1.845-.863-3.003H8.473l.372-1.431h1.668l-.018-.285-.006-.29v-.624l.003-.306c.009-.398.036-.757.08-1.077H8.474l.372-1.431h1.968l.086-.36c.214-.829.515-1.557.903-2.185.444-.717.966-1.313 1.566-1.786.6-.473 1.262-.825 1.986-1.058.724-.232 1.478-.349 2.262-.349zM10.433 4.032l-.126.077 3.604 5.467h5.568l3.237-5.81-.292-.039c-1.135-.123-2.567.025-4.295.471l-.528.143c-.283.08-.583.071-.86-.026-2.888-1.009-4.947-1.062-6.308-.283z'
		/>
	</svg>
);

const Calendar = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='38'
		height='38'
		viewBox='0 0 38 38'
	>
		<path
			fill='#9E9E9E'
			fillRule='evenodd'
			d='M10.857 0c.75 0 1.357.61 1.357 1.357v1.357h13.572V1.357c0-.746.608-1.357 1.357-1.357S28.5.61 28.5 1.357v1.357h2.714C34.961 2.714 38 5.754 38 9.5v21.714C38 34.96 34.961 38 31.214 38H6.786C3.039 38 0 34.96 0 31.214V9.5c0-3.746 3.039-6.786 6.786-6.786H9.5V1.357C9.5.611 10.108 0 10.857 0zM9.624 5.7h-2.71C4.67 5.7 2.85 7.516 2.85 9.765v2.71h32.517v-2.71c0-2.25-1.82-4.065-4.065-4.065h-2.71v1.355c0 .745-.607 1.355-1.355 1.355-.747 0-1.354-.61-1.354-1.355V5.7H12.334v1.355c0 .745-.607 1.355-1.355 1.355S9.624 7.8 9.624 7.055V5.7zm25.743 9.5H2.85v16.258c0 2.25 1.82 4.065 4.065 4.065h24.387c2.245 0 4.065-1.816 4.065-4.065V15.2zM8.55 22.255c0-.745.607-1.355 1.355-1.355h2.71c.747 0 1.354.61 1.354 1.355s-.607 1.355-1.354 1.355h-2.71c-.748 0-1.355-.61-1.355-1.355zm7.6 0c0-.745.607-1.355 1.355-1.355h2.71c.747 0 1.354.61 1.354 1.355s-.607 1.355-1.354 1.355h-2.71c-.748 0-1.355-.61-1.355-1.355zm8.55 0c0-.745.607-1.355 1.355-1.355h2.71c.747 0 1.354.61 1.354 1.355s-.607 1.355-1.354 1.355h-2.71c-.748 0-1.355-.61-1.355-1.355zm-16.15 6.65c0-.745.607-1.355 1.355-1.355h2.71c.747 0 1.354.61 1.354 1.355s-.607 1.355-1.354 1.355h-2.71c-.748 0-1.355-.61-1.355-1.355zm7.6 0c0-.745.607-1.355 1.355-1.355h2.71c.747 0 1.354.61 1.354 1.355s-.607 1.355-1.354 1.355h-2.71c-.748 0-1.355-.61-1.355-1.355zm8.55 0c0-.745.607-1.355 1.355-1.355h2.71c.747 0 1.354.61 1.354 1.355s-.607 1.355-1.354 1.355h-2.71c-.748 0-1.355-.61-1.355-1.355z'
		/>
	</svg>
);

const SloganBlock = ({ text, type }) => {
	if (text) return <div className='ps-sparent-text'>{text}</div>;

	switch (type) {
		case TYPES.PS: return (
			<div className='ps-sparent-text'>
				Dieses Projekt wurde aus den Mitteln des örtlichen Reinertrags der <span>PS-Lotterie</span> unterstützt.
			</div>
		);
		case TYPES.FOUNDATION: return (
			<div className='ps-sparent-text'>
				Dieses Projekt wurde aus den Mitteln unserer Stiftung unterstützt.
			</div>
		);
		default: return null;
	}
};

const ProjectsSupported = (props) => {
	const { match, isImported, location } = props;
	const urlId = match && match.params ? match.params.id : null;
	const name = match && match.params ? match.params.name : null;
	const receiverType = location.search && new URLSearchParams(location.search).get('receiver_type');
	const requestId = location.search && new URLSearchParams(location.search).get('request_id');
	const startDate = location.search && new URLSearchParams(location.search).get('start_date');
	const isPartnerProject = receiverType?.toString() === '1';

	const dispatch = useDispatch();

	const branches = useSelector(selectBranches);
	const settingsZw = useSelector(selectSettingsZw);
	const settingsSt = useSelector(selectSettingsSt);

	const [isFetched, toggleFetched] = useState(false);
	const [project, setProject] = useState(null);
	const [partnerProject, setPartnerProject] = useState(null);

	const { data: arrBranches } = branches.data;
	const searchAlias = name?.toLowerCase();
	const branch = arrBranches.find(i => i.alias === searchAlias || i.alias2 === searchAlias);
	const branchId = branch ? branch.id : null;
	const is404 = !project || ((project.branch || project.branch_id) !== branchId);

	useEffect(() => {
		AuthService.getSupportedProject(urlId, isImported, isPartnerProject, requestId).then(result => {
			if (result.branch || result.id) {
				setProject(result);
				if (result.funding_request_type === TYPES.PS) {
					dispatch(settingsZwActions.loadSettingsZw(branchId));
				}
				if (result.funding_request_type === TYPES.FOUNDATION) {
					dispatch(settingsStActions.loadSettingsSt(branchId));
				}
			}
			toggleFetched(true);
		}).catch(err => {
			console.warn(err);
			toggleFetched(true);
		});
		if (isPartnerProject) {
			AuthService.projectById(urlId).then(result => {
				if (result.id) setPartnerProject(result);
			}).catch(err => {
				console.warn(err);
			});
		}
	}, [urlId]);

	const SloganText = useCallback(() => {
		if (!project) return null;
		switch (project.funding_request_type) {
			case TYPES.PS: return <SloganBlock text={settingsZw.slogan} type={project.funding_request_type} />;
			case TYPES.FOUNDATION: {
				const slogan = project.foundations?.[0]?.slogan;
				return <SloganBlock text={slogan} type={project.funding_request_type} />;
			}
			default: return null;
		}
	}, [project, settingsZw, settingsSt]);

	const showReachedAmount = useCallback(() => {
		const amount = isImported ? +project?.reached_amount : +project?.transactions_amount;
		return project?.funding_request_type !== TYPES.SPONSORING && !!amount;
	}, [project, isImported]);

	// TODO: check and if need change key[egm] and key[logo]
	// add CSS.egm - logo
	const styleLogo = { maxHeight: '34px', transform: 'translate(5px, -4px)' };
	const styleEgmWrap = { textAlign: 'center' };
	const EGM = useCallback(() =>
		isImported ?
			<EGMTextWrap style={styleEgmWrap} className='ps-sparent-text'>
				Dieses Projekt wurde gefördert auf:
				<img className='egm-logo' style={styleLogo} src={EGM_LOGO} alt='logo' loading='lazy' />
			</EGMTextWrap>
			: null
		, [project]);

	const addZeroToNum = num => {
		if (num < 10) {
			return `0${num}`;
		} return num;
	};

	const convertDate = (date) => {
		const dateObj = dayjs(date);
		const month = addZeroToNum(dateObj.month() + 1);
		const day = addZeroToNum(dateObj.date());
		const year = dateObj.year();
		return `${day}.${month}.${year}`;
	};

	const getDateAmount = () => {
		if (isImported) {
			const startDate = dayjs(project.start_date);

			return `${addZeroToNum(startDate.date())}.${addZeroToNum(startDate.month() + 1)} - ${convertDate(project.end_date)}`;
		}

		const projectStartDate = startDate ? decodeURIComponent(startDate) : project.start_date;

		return convertDate(projectStartDate);
	};

	const renderDescription = (description) => {
		const isHtml = /<\/?[\w\s="/.':;#-]+>/gi.test(description);

		return isHtml
			? <ProjectDescription dangerouslySetInnerHTML={{ __html: description}} />
			: <ProjectDescription>{description}</ProjectDescription>;
	};

	if (isFetched && is404) {
		return <Page404 />;
	}

	if (isFetched && project) {
		const projectDescription = partnerProject?.summary || project.description;
		const canShowFurtherInfo = isPartnerProject && project.description;
		const title = partnerProject?.title || project.title;

		return (
			<Wrapper>
				<Helmet title={title}>
					<meta property='og:title' content={title} />
				</Helmet>

				<Header>
					<TopBarAllPages {...props} />
				</Header>

				<Container>
					<ProjectTitle>{title}</ProjectTitle>
					<ProjectOrganizationName>{decodeHtmlEntities(partnerProject?.carrier_name || project.organization_name)}</ProjectOrganizationName>

					<ProjectSubTitle>
						<Row className='justify-content-center' style={{ flexWrap: IS_MOBILE ? 'wrap' : 'nowrap' }}>
							{showReachedAmount() && (
								<ProjectsSupportedSubTitle
									title='Gefördert mit'
									amount={convertToEuro(isImported ? +project.reached_amount : +project.transactions_amount)}
								>
									<Amount />
								</ProjectsSupportedSubTitle>
							)}

							{isImported && (
								<ProjectsSupportedSubTitle title='Davon von der Sparkasse' amount={convertToEuro(project.featured_donations)}>
									<Shape />
								</ProjectsSupportedSubTitle>
							)}

							{isImported && (
								<ProjectsSupportedSubTitle title='Zahl der Unterstützungen' amount={project.number_of_donations}>
									<Heart />
								</ProjectsSupportedSubTitle>
							)}

							<ProjectsSupportedSubTitle title='Datum' amount={getDateAmount()}>
								<Calendar />
							</ProjectsSupportedSubTitle>
						</Row>
						<Row>
							<Col lg='12' className='d-flex justify-content-center flex-column align-items-center'>
								<ProjectDivider />
								{SloganText()}
								{EGM()}
							</Col>
							<Col lg='12' className='d-flex justify-content-center align-items-center'>
								<Image src={partnerProject?.image || project.image} alt='' fluid loading='lazy' />
							</Col>
							<Col lg='12' className='d-flex justify-content-center'>
								<ProjectDivider />
							</Col>

							<Col
								lg='12'
								className='d-flex mb-5 justify-content-center'
							>
								{renderDescription(projectDescription)}
							</Col>
						</Row>
						{canShowFurtherInfo && <>
							<Row>
								<Col lg='12' className='d-flex justify-content-center'>Weitere Informationen</Col>
							</Row>
							<Row>
								<Col lg='12' className='d-flex justify-content-center mb-5'>
									{renderDescription(project.description.replaceAll('\r\n', '<br>'))}
								</Col>
							</Row>
						</>}
					</ProjectSubTitle>
				</Container>

				<Footer>
					<BottomBar />
				</Footer>
			</Wrapper>
		);
	}

	return <div />;
};

ProjectsSupported.propTypes = {
	match: PropTypes.object,
	isImported: PropTypes.bool
};

ProjectsSupported.defaultProps = {
	match: null,
	isImported: false
};

export default ProjectsSupported;
export { ProjectsSupported };
